import { apiClient } from './api.client';
import type { NotificationPayload } from '../types/notifications';

export interface InboxPage { items: NotificationPayload[]; cursor: number; has_more: boolean }
export const notificationInbox = {
  list: async (after = 0, bootstrap = false, signal?: AbortSignal) => {
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (signal?.aborted) controller.abort();
    signal?.addEventListener('abort', abort);
    const timeout = setTimeout(abort, 15000);
    try { return await apiClient.get<InboxPage>('/notifications/inbox', { after, bootstrap }, { signal: controller.signal }); }
    finally { clearTimeout(timeout); signal?.removeEventListener('abort', abort); }
  },
  read: (id: string) => apiClient.post(`/notifications/inbox/${encodeURIComponent(id)}/read`, {}),
  readAll: () => apiClient.post('/notifications/inbox/read-all', {}),
  dismiss: (id: string) => apiClient.delete(`/notifications/inbox/${encodeURIComponent(id)}`),
  dismissAll: () => apiClient.post('/notifications/inbox/dismiss-all', {}),
};
